var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "van-cell-group",
        [
          _vm.refundShow
            ? _c("van-cell", {
                attrs: {
                  title: "申请退货",
                  "is-link": "",
                  value: "",
                  size: "large"
                },
                on: { click: _vm.openRefund }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.setupOrRepairedShow
            ? _c("van-cell", {
                attrs: {
                  title: "申请安装",
                  "is-link": "",
                  value: "",
                  size: "large"
                },
                on: {
                  click: function($event) {
                    _vm.esvOpenPage({
                      name: "OPApplyAfterSales",
                      query: { type: "install" }
                    })
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.setupOrRepairedShow
            ? _c("van-cell", {
                attrs: {
                  title: "申请维修",
                  "is-link": "",
                  value: "",
                  size: "large"
                },
                on: {
                  click: function($event) {
                    _vm.esvOpenPage({
                      name: "OPApplyAfterSales",
                      query: { type: "repair" }
                    })
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("van-cell", {
            attrs: {
              title: "查看售后历史",
              "is-link": "",
              value: "",
              size: "large"
            },
            on: {
              click: function($event) {
                _vm.esvOpenPage({
                  name: "OPAfterSalesList",
                  query: { type: "order" }
                })
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("img", {
        attrs: {
          src: require("../assets/img/myCenter/afterSalesHeader@3x.png"),
          alt: ""
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }